import Model from "./base/model";

class TransporterTde extends Model{
  resourceName() {
    return "transporter_tde";
  }

  fields() {
    return {
      transporter_id: "",
      city_id: "",
      city: "",
      cnpj_cpf: "",
      social_reason: "",
      transporter: { jsonApi: "hasOne", type: "transporters"},

    };
  }

}

export default new TransporterTde();
